import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageButtonComponent} from '../buttons/page-button.component';
import {BorderIconButtonComponent} from '../buttons/border-icon-button.component';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {LoyaltyProgram} from '../../models/loyalty-program';
import {ActivatedRoute, Router} from '@angular/router';
import {AppStateService} from '../../services/app-state.service';
import {TranslateService} from '../../services/translate.service';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {AuthorizedApiService} from '../../services/authorized-api.service';
import {LightIconButtonComponent} from '../buttons/light-icon-button-component';
import {LoadingSpinnerComponent} from './loading-spinner-component';
import {UrlHistoryService} from '../../services/url.history.service';
import {LinkButtonComponent} from '../buttons/link-button.component';
import {ModalService} from '../../services/modal.service';
import {ConfirmDialogComponent} from '../dialogs/confirm-dialog-component';

@Component({
  standalone: true,
  imports: [CommonModule, PageButtonComponent, BorderIconButtonComponent, ActionButtonComponent, LightIconButtonComponent, LoadingSpinnerComponent, LinkButtonComponent],
  selector: 'app-loyalty-card',
  template: `
    <div *ngIf="cardData" class="py-8">
      <div class="mx-4 shadow-xl rounded-lg flex flex-col">
        <!--Header-->
        <div class="bg-theme-primary rounded-t-xl h-14 flex items-center px-4 gap-3">
          <i class="font-bold text-xl text-theme-contrast fas fa-crown"></i>
          <div class="flex-1 font-bold text-xl text-theme-contrast">{{cardData.program_name}}</div>
        </div>

        <!--Body-->
        <div class="flex-1 border-2 border-theme-primary flex flex-col items-center py-8">
          <div class="p-1 border-8 rounded-lg border-theme-text">
            <img class="w-40 h-40" src="https://steward.heynows.com/qr?content={{cardData.identity}}&size=110&margin=1">
          </div>
          <div *ngIf="cardData.points" class="flex flex-row text-base items-center gap-2 mt-4">
            <i class="fas fa-star"></i>
            <div class="font-bold">{{ getString("Poäng") }}</div>
          </div>
          <div *ngIf="cardData.points">
            <div class="font-bold text-2xl">{{cardData.points}}</div>
          </div>
<!--          <div class="mt-8 mb-6">-->
<!--            <app-light-icon-button [leftIcon]="'fa-plus-circle'" (onClick)="refill()" [text]="refillButtonTitle"></app-light-icon-button>-->
<!--          </div>-->
        </div>

        <!--Footer-->
        <div class="bg-theme-primary rounded-b-lg min-h-14 px-8 justify-evenly flex-col flex font-bold text-theme-contrast items-end text-sm">
          <div *ngIf="cardData.valid_to">
            {{getString("Giltlig till:")}} {{cardData.valid_to}}
          </div>
          <div>
            {{cardData.identity}}
          </div>
          <div>
            {{cardData.first_name}}
          </div>
        </div>
      </div>
    </div>

    <div class="my-6 mx-4 flex justify-between">
      <app-link-button [leftIcon]="'fa-rectangle-history'" (onClick)="navHistory()" [text]="'Visa historik'"></app-link-button>
      <app-link-button [leftIcon]="'fa-trash-alt'" (onClick)="unlinkLoyaltyCard()" [text]="'Ta bort kort'"></app-link-button>
    </div>

    <div *ngIf="!cardData" class="h-[36rem] flex items-center justify-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  `
})
export class LoyaltyCardComponent implements OnInit, OnDestroy {
  @Input() cardData: LoyaltyProgram | null = null;

  constructor(private appStateService: AppStateService, private api: AuthorizedApiService,
              private identity: UrlHistoryService, private router: Router, private modalService: ModalService,
              protected translate: TranslateService, private sheetService: BottomSheetService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  getString(s: string, pc: string = "normal") {
    return this.translate.single(s, pc);
  }

  wipeLoyaltyCard = () => {
    console.log('Wiping loyalty card');
    this.api.unlinkLoyaltyCard(this.cardData!.key).subscribe(() => {
      this.sheetService.popSheet();
    });
  }

  unlinkLoyaltyCard() {
    this.modalService.show(ConfirmDialogComponent, {
      data: {
        title: 'Ta bort lojalitetskort',
        message: 'Är du säker på att du vill ta bort ditt lojalitetskort?',
        confirmText: 'Ta bort',
        abortText: 'Avbryt',
        positiveAction: this.wipeLoyaltyCard
      }
    });
  }

  navHistory() {
    this.router.navigate([this.appStateService.venueId, 'loyalty-history', this.cardData!.key]);
    this.sheetService.popSheet(2);
  }
}
